import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { MultiSelectModule } from 'primeng/multiselect';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { NewMessageComponent } from './new-message.component';
import { NewMessageFacade } from './new-message.facade';

@NgModule({
  declarations: [NewMessageComponent],
  exports: [NewMessageComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CheckboxModule,
    DataViewModule,
    MultiSelectModule,
    StepsModule,
    TabMenuModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [NewMessageFacade],
})
export class NewMessageModule {}
